import axios from 'axios';
export function fetchSessionJson(params,baseURL,sessionToken){
    return new Promise((resolve,reject)=>{
         console.log(sessionToken); 
         let headers = Object.assign({'sessionToken':sessionToken,'Content-Type': 'application/json'},params.headers);
         const  instance = axios.create({
            headers: headers,  //用来验证是否登录
            baseURL: baseURL,
            timeout: 30000
        });
        instance(params.options).then(response=>{
            const  res = response;
            resolve(res);
        }).catch(err=>{
          console.log(err);
          resolve(err);
        });

    })
}
